import { render, staticRenderFns } from "./BulkLinkBillDialog.vue?vue&type=template&id=1f53baea"
import script from "./BulkLinkBillDialog.vue?vue&type=script&lang=js"
export * from "./BulkLinkBillDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports